import {
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const CityCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <SimpleForm toolbar={<CreateToolbar />}>
      <TextInput
        source="name"
        helperText="example: Moscow"
        validate={required()}
      />
      <TextInput source="heartbeatName" validate={required()} />
    </SimpleForm>
  </Create>
);
